/**
 * Nombre del item que se está viendo, para que el Breadcrumb no tenga que pedirlo.
 *
 * Antes la miga de pan hacía su propio `GET /api/gotrading/dynamic/<modelo>/<id>` solo
 * para leer un campo. En un embarque eso son ~200 KB y unos 700 ms, duplicando la misma
 * petición que la ficha ya estaba haciendo en el mismo milisegundo.
 *
 * Ahora la ficha publica acá el nombre cuando carga el item, y el Breadcrumb lo lee.
 * Mismo patrón observable que utils/routerNavigationLoading.js.
 */
import Vue from "vue";

export const currentItemLabel = Vue.observable({
  itemId: "",
  label: "",
});

export function setCurrentItemLabel(itemId, label) {
  currentItemLabel.itemId = itemId ? String(itemId) : "";
  currentItemLabel.label = label ? String(label) : "";
}

export function clearCurrentItemLabel() {
  currentItemLabel.itemId = "";
  currentItemLabel.label = "";
}

/** Nombre publicado para ese id, o "" si todavía no llegó o es de otro item. */
export function getCurrentItemLabel(itemId) {
  if (!itemId || currentItemLabel.itemId !== String(itemId)) return "";
  return currentItemLabel.label || "";
}

/**
 * Nombre aproximado a partir del slug de la URL legible (/i/shipping-op5496-2026-<id>).
 *
 * Es el respaldo para el primer instante, antes de que la ficha publique el nombre real:
 * el slug perdió mayúsculas y puntuación, así que "OP5496/2026-." vuelve como
 * "Op5496 2026". Sirve para no mostrar un `#a1b2c3` mientras carga.
 */
export function labelFromTitleSlug(titleSlug) {
  const raw = String(titleSlug || "").trim();
  if (!raw) return "";

  return raw
    .split("-")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ")
    .substring(0, 50);
}

/**
 * Nombre visible de un item. Misma lista de campos que usaba el Breadcrumb cuando lo
 * resolvía por su cuenta, para que la etiqueta no cambie respecto de antes.
 */
export function buildItemDisplayName(item) {
  if (!item) return "";

  const fields = [
    "name",
    "nombre",
    "title",
    "titulo",
    "code",
    "codigo",
    "id_number",
    "identifier",
  ];
  for (const f of fields) {
    if (item[f]) return String(item[f]).substring(0, 50);
  }
  return item._id ? `#${String(item._id).slice(-6)}` : "";
}
